module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "banner-field"
  }, [_c('slider', {
    attrs: {
      "items": _vm.banners
    }
  })], 1), _vm._v(" "), _vm._l((_vm.feeds), function(feed, index) {
    return _c('div', {
      staticClass: "feeds"
    }, [_c('feed', {
      key: index,
      attrs: {
        "linker": _vm.articleLinker(feed),
        "title": feed.title,
        "desciption": feed.content,
        "author": feed.user.id,
        "board": feed.board,
        "attachment": feed.attachment ? feed.attachment : false
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "load-more card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('a', {
    class: 'card-header-title button is-primary ' + _vm.isButtonLoading,
    on: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("加载更多...")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78caae73","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Timeline.vue
// module id = 249
// module chunks = 1